/**
 * @todo Удалить файл
 * @description Данный функционал появился в задаче CD-246443, будет удалён в задаче CD-245113
 * Если переходим на базулу, то покрыть тестами
 * Если остаёмся на адфоксе, то удалить директорию полностью
 */

import { BuzzoolaBannerWithHide, BuzzoolaBannerWithHideProps } from '@cian/buzzoola-component';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { selectAdfoxPuids } from '../../selectors/adfox';

type BuzzoolaBannerContainerProps = Omit<BuzzoolaBannerWithHideProps, 'thirdPartyRequestParams'>;

export const BuzzoolaBannerContainer: FC<BuzzoolaBannerContainerProps> = props => {
  const puids = useSelector(selectAdfoxPuids);

  return <BuzzoolaBannerWithHide {...props} thirdPartyRequestParams={puids} />;
};
